import manual from '@/views/manual/manual.vue'
import login from '@/plugins/login.js';

export default {
    id: 'manual',
    path: '/manual',
    name: 'Manual',
    component: manual,
    isHeader: false,
    hidden: false,
    icone: 'book',
    meta: {
        auth: true,
        titulo: 'Manual de uso',
        descricao: 'Vizualize ou baixe o manual.',
        possuiNivel: login.validarNivel('Pesquisa')
    },
}